import { ISpendBasedConversion } from '../services/spend-based-conversion/spend-based-conversion.model';

export const convertKgToTonne = (amount: number, decimalCount: number) => {
  return parseFloat((amount / 1000).toFixed(decimalCount))
}

export const convertSqftToMTwo = (amount: number) => {
  return amount / 10.764
}

export const startYear = 2018;
export const endYear = 2030;

// Spend based conversions can carry no code: the column is nullable and custom factor imports
// create rows without one. Everything that sorts, searches or labels by the code goes through
// these helpers so a missing value can never reach a string method.
export const MISSING_CONVERSION_CODE = '—'

export const conversionCode = (conversion: Pick<ISpendBasedConversion, 'localAuthorityCustomIdentifier'>): string =>
  conversion.localAuthorityCustomIdentifier ?? ''

export const compareByConversionCode = (
  a: Pick<ISpendBasedConversion, 'localAuthorityCustomIdentifier'>,
  b: Pick<ISpendBasedConversion, 'localAuthorityCustomIdentifier'>
): number => conversionCode(a).localeCompare(conversionCode(b))

export const sortByConversionCode = <T extends Pick<ISpendBasedConversion, 'localAuthorityCustomIdentifier'>>(
  conversions: readonly T[] | undefined | null
): T[] => (conversions ? [...conversions].sort(compareByConversionCode) : [])

export const formatConversionCodeLabel = (
  conversion: Pick<ISpendBasedConversion, 'localAuthorityCustomIdentifier' | 'activity'>,
  separator: string = ':'
): string => `Code ${conversionCode(conversion) || MISSING_CONVERSION_CODE}${separator} ${conversion.activity ?? ''}`

export const createDisplayFormatSpendBasedConversion = (
  conversion: ISpendBasedConversion,
  codeField: string = 'localAuthorityCustomIdentifier',
  middleField: string = 'id',
  descriptionField: string = 'activity',
  template: string = 'Code {codeField}: {descriptionField}'
) => {
  const code = conversion[codeField as keyof ISpendBasedConversion]
  const middle = conversion[middleField as keyof ISpendBasedConversion]
  const description = conversion[descriptionField as keyof ISpendBasedConversion]

  const displayValue = (value: unknown, fallback: string = '') =>
    value === null || value === undefined ? fallback : String(value)

  const displayText = template
    .replace('{codeField}', displayValue(code, MISSING_CONVERSION_CODE))
    .replace('{middleField}', displayValue(middle))
    .replace('{descriptionField}', displayValue(description))

  return {
    ...conversion,
    displayCode: code,
    displayMiddle: middle,
    displayDescription: description,
    displayText
  }
}
